<template>
  <div class="add-to-basket">
    Test
  </div>
</template>

<script>
export default {
  data() {
    return {
      //
    };
  },

  props: {
    myProp: {
      type: Number,
    },
  },

  watch: {
    //
  },

  mounted() {
    //
  },

  methods: {
    //
  },
};
</script>
